import { useNotification } from "@refinedev/core";
import { useCallback, useState } from "react";
import { httpClient, ROOT_URL } from "../../App";
import { getErrorMessage } from "../../api/error";
import PaymentStatus from "../../types/paymentStatus.type";
import { IDocumentsChanges } from "../components/interface";
import { InvoiceReceivable } from "./EditInvoiceReceivable";

interface UpdateInvoiceReceivableData
  extends Pick<InvoiceReceivable["paymentOrder"], "specialInstructions"> {
  status: PaymentStatus;
  documentChanges?: IDocumentsChanges;
  reason?: string | null;
}
export const useUpdateInvoiceReceivable = (id?: number) => {
  const [isLoading, setIsLoading] = useState(false);

  const { open: openNotification } = useNotification();

  const update = useCallback(
    async (data: UpdateInvoiceReceivableData) => {
      if (id) {
        try {
          setIsLoading(true);
          const { specialInstructions, documentChanges, status, reason } = data;

          const updateData = {
            id,
            documentChanges:
              documentChanges?.new?.length || documentChanges?.deleted?.length
                ? documentChanges
                : undefined,
            status,
            specialInstructions,
            reason,
          };
          await httpClient.patch(
            `${ROOT_URL}/api/v1/invoice_receivables/update`,
            updateData
          );
          setIsLoading(false);
          if (openNotification) {
            openNotification?.({
              key: "success_transaction",
              type: "success",
              message: `Update invoice successfully`,
            });
          }
          return true;
        } catch (error) {
          if (openNotification) {
            openNotification({
              key: "edit_failure",
              message: `Error editing invoice #${id}`,
              description: getErrorMessage(error) || "Something went wrong",
              type: "error",
            });
          }
          setIsLoading(false);
          return false;
        }
      }
    },
    [id, openNotification]
  );

  return { update, isLoading };
};
